import { useEffect, useState } from "react";

const FONT_FAMILIES = {
  outlined: "Material Symbols Outlined",
  rounded: "Material Symbols Rounded",
  sharp: "Material Symbols Sharp"
};

export const useMaterialFontReady = (type = "outlined") => {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const font = FONT_FAMILIES[type];
    if (!font) {
      console.warn(`Unsupported Material Symbol type: "${type}"`);
      setReady(false);
      return;
    }

    const fontStr = `1em "${font}"`;
    let cancelled = false;

    if (document.fonts.check(fontStr)) {
      setReady(true);
      return;
    }

    setReady(false);
    document.fonts.load(fontStr).then(() => {
      if (!cancelled && document.fonts.check(fontStr)) {
        setReady(true);
      }
    });

    return () => {
      cancelled = true;
    };
  }, [type]);

  return ready;
};
